export default [{
  path: '/configuration',
  name: '系统管理',
  component: resolve => require(['@/views/home'], resolve),
  children: [
    
    {
      path: 'Workbench',
      name: '工作台',
      meta: {
        title: '工作台'
      },
      component: resolve => require(['@/views/configuration/Workbench'], resolve),
    },
    {
      path: 'siteManagement',
      name: '站点管理',
      meta: {
        title: '站点管理'
      },
      component: resolve => require(['@/views/configuration/siteManagement'], resolve),
    },
    {
      path: 'BasicInfoManagement',
      name: '基本信息管理',
      meta: {
        title: '基本信息管理'
      },
      component: resolve => require(['@/views/configuration/BasicInfoManagement'], resolve),
    },
  ]
},


]



// WEBPACK FOOTER //
// ./src/router/configuration_routers.js